import {
  DownloadOutlined,
  EyeOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";
import { Button, Flex, Form, Input, Table, Tooltip, Typography } from "antd";
import { Card, Col, Collapse, List, Row } from "antd";
import React, { FC, useEffect, useState } from "react";
import dayjs from "dayjs";

const { Panel } = Collapse;
const { Text } = Typography;

type ViewEnhancementCghsProps = {
  enhancementsList: any;
  handleOpen: any;
  closeViewAddedEnhancement: any;
  viewEnhancement: boolean;
  isFetchingEnhancementData: boolean;
  isCghsNew?: boolean;
  enhancementReasonOptions?: any;
  /** Show "PreAuth" badge — Ayushman enhancement only */
  showPreAuthLabel?: boolean;
};

const ViewEnhancementCghs: FC<ViewEnhancementCghsProps> = (props) => {
  // const filteredEnhancement = props?.enhancementsList?.filter((enhancementItem: any) => enhancementItem?.enhancementProceduresResponseList);

  const calculateTotal = (data: any[]) => {
    return data?.reduce((sum: number, procedure: any) => {
      const amount = procedure?.unspecifiedProcedureAmount
        ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
          parseFloat(procedure?.numberOfDays)
        : parseFloat(procedure?.procedureAmount || "0") *
          parseFloat(procedure?.numberOfDays);
      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  return (
    <Modal
      loading={props?.isFetchingEnhancementData}
      title={
        <div>
          <span style={{ fontSize: "1rem", fontWeight: "600" }}>
            ENHANCEMENT
          </span>
        </div>
      }
      centered
      width={2000}
      open={props?.viewEnhancement}
      onCancel={props?.closeViewAddedEnhancement}
      footer={null}
      style={{ boxShadow: "0px 4px 20px 0px #00000040", width: "149%" }}
      className="new-view-enhancement-ihx"
    >
      <List
        grid={{ gutter: 16, column: 1 }}
        dataSource={props?.enhancementsList}
        renderItem={(item: any, index) => (
          <List.Item>
            <Card
              className="enhancement-card"
              title={`Enhancement-${props?.enhancementsList?.length - index}`}
              style={{ cursor: "pointer", backgroundColor: "white" }}
            >
              <Collapse defaultActiveKey={["1"]}>
                <Panel header="Procedure" key="1">
                  <Form>
                    {item?.enhancementProceduresResponseList &&
                    item?.enhancementProceduresResponseList?.length > 0 ? (
                      item?.enhancementProceduresResponseList?.map(
                        (procedure: any) => (
                          <Row
                            key={procedure?.id}
                            gutter={[16, 16]}
                            align="top"
                            style={{
                              border: "1px solid #008B8B",
                              padding: "10px 20px",
                              borderRadius: "16px",
                              marginBottom: "0.8rem",
                              background: "white",
                              boxShadow: "0px 2px 8px 0px #00000040",
                            }}
                          >
                            <Col span={24}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: 8,
                                  gap: 8,
                                  flexWrap: "wrap",
                                }}
                              >
                                {props?.showPreAuthLabel &&
                                procedure?.fromPreAuth === true ? (
                                  <span
                                    style={{
                                      background: "#004C8F",
                                      color: "#fff",
                                      borderRadius: 12,
                                      padding: "2px 10px",
                                      fontSize: 12,
                                      fontWeight: 600,
                                    }}
                                  >
                                    PreAuth
                                  </span>
                                ) : props?.showPreAuthLabel &&
                                  (procedure?.createdAt || item?.createdAt) ? (
                                  <span
                                    style={{
                                      fontSize: 12,
                                      color: "#555",
                                      fontWeight: 500,
                                      letterSpacing: 0.2,
                                    }}
                                  >
                                    ENHANCEMENT DATE:{" "}
                                    {dayjs(
                                      procedure?.createdAt || item?.createdAt,
                                    ).isValid()
                                      ? dayjs(
                                          procedure?.createdAt ||
                                            item?.createdAt,
                                        ).format("DD-MM-YYYY HH:mm:ss")
                                      : String(
                                          procedure?.createdAt ||
                                            item?.createdAt,
                                        )}
                                  </span>
                                ) : (
                                  <span />
                                )}
                              </div>
                            </Col>

                            <Col span={8}>
                              <Form.Item
                                label="Procedure"
                                name={"procedureName"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={procedure?.procedureName}
                                  disabled={true}
                                  style={{ color: "black" }}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={7}>
                              <Form.Item
                                label="Procedure Code"
                                name={"externalProcedureCode"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                  placeholder="Enter Procedure Code"
                                  disabled={true}
                                  defaultValue={
                                    procedure?.externalProcedureCode
                                  }
                                />
                              </Form.Item>
                            </Col>

                            <Col span={8}>
                              <Form.Item
                                label="QUANTITY/NO OF DAYS"
                                name={"numberOfDays"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  defaultValue={procedure?.numberOfDays}
                                  disabled={true}
                                  placeholder="Enter QUANTITY/NO OF DAYS"
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            {/* <Col span={8}>
                              <Form.Item
                                label="ACCREDITATION STATUS"
                                name={"accreditationStatus"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  disabled={true}
                                  defaultValue={procedure?.accreditationStatus}
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                />
                              </Form.Item>
                            </Col>

                            <Col span={7}>
                              <Form.Item
                                label="TREATING DOCTOR"
                                name={"treatingDoctor"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Input
                                  disabled={true}
                                  defaultValue={procedure?.treatingDoctor}
                                  style={{
                                    borderRadius: "5px",
                                    color: "black",
                                  }}
                                />
                              </Form.Item>
                            </Col> */}

                            <Col span={8}>
                              <Form.Item
                                label="TREATMENT START DATE"
                                name={"treatmentStartDate"}
                                rules={[
                                  { required: true, message: "Required" },
                                ]}
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                }}
                              >
                                <Input
                                  disabled={true}
                                  defaultValue={procedure?.treatmentStartDate}
                                  style={{ color: "black" }}
                                />
                              </Form.Item>
                            </Col>

                            {!procedure?.specialityType
                              ?.toLowerCase()
                              ?.includes("s") && !procedure?.unspecifiedProcedureName ? (
                              <Col span={8}>
                                <Form.Item
                                  label="AMOUNT"
                                  name={"procedureAmount"}
                                  rules={[
                                    { required: true, message: "Required" },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Input
                                    defaultValue={procedure?.procedureAmount}
                                    style={{
                                      borderRadius: "5px",
                                      color: "black",
                                    }}
                                    placeholder="Enter Amount"
                                    disabled={true}
                                  />
                                </Form.Item>
                              </Col>
                            ) : (
                              <></>
                            )}

                            {procedure?.specialityType
                              ?.toLowerCase()
                              ?.includes("s") || procedure?.unspecifiedProcedureName ? (
                              <Col span={8}>
                                <Form.Item
                                  label="PROCEDURE NAME"
                                  name={"unspecifiedProcedureName"}
                                  rules={[
                                    { required: true, message: "Required" },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Input
                                    defaultValue={
                                      procedure?.unspecifiedProcedureName
                                    }
                                    style={{
                                      borderRadius: "5px",
                                      color: "black",
                                    }}
                                    placeholder="Enter Procedure Name"
                                    disabled={true}
                                  />
                                </Form.Item>
                              </Col>
                            ) : (
                              <></>
                            )}

                            {procedure?.specialityType
                              ?.toLowerCase()
                              ?.includes("s") || procedure?.unspecifiedProcedureName ? (
                              <Col span={7}>
                                <Form.Item
                                  label="PROCEDURE AMOUNT"
                                  name={"unspecifiedProcedureAmount"}
                                  rules={[
                                    { required: true, message: "Required" },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Input
                                    defaultValue={
                                      procedure?.unspecifiedProcedureAmount
                                    }
                                    style={{
                                      borderRadius: "5px",
                                      color: "black",
                                    }}
                                    placeholder="Enter Procedure Amount"
                                    disabled={true}
                                  />
                                </Form.Item>
                              </Col>
                            ) : (
                              <></>
                            )}

                            {props?.showPreAuthLabel ? (
                              (() => {
                                const stratificationDisplay =
                                  procedure?.stratificationName ||
                                  procedure?.stratification?.name ||
                                  procedure?.stratsName ||
                                  "";
                                if (!stratificationDisplay) return null;
                                return (
                                  <Col span={8}>
                                    <Form.Item
                                      label="Stratification"
                                      name={"stratificationName"}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        defaultValue={stratificationDisplay}
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Stratification"
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </Col>
                                );
                              })()
                            ) : (
                              <>
                                {procedure?.strats
                                  ?.toLowerCase()
                                  ?.includes("y") ? (
                                  <Col span={7}>
                                    <Form.Item
                                      label="STRATS NAME"
                                      name={"stratsName"}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Required",
                                        },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        defaultValue={procedure?.stratsName}
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Strats Name"
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : (
                                  <></>
                                )}

                                {procedure?.strats
                                  ?.toLowerCase()
                                  ?.includes("y") ? (
                                  <Col span={8}>
                                    <Form.Item
                                      label="STRATS OPTIONS"
                                      name={"stratOptionValue"}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Required",
                                        },
                                      ]}
                                      labelCol={{ span: 24 }}
                                      wrapperCol={{ span: 24 }}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Input
                                        defaultValue={
                                          procedure?.stratOptionValue
                                        }
                                        style={{
                                          borderRadius: "5px",
                                          color: "black",
                                        }}
                                        placeholder="Enter Strats Option"
                                        disabled={true}
                                      />
                                    </Form.Item>
                                  </Col>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}

                            {props?.isCghsNew ? (
                              <Col span={8}>
                                <Form.Item
                                  label="Enhancement Reason"
                                  name={"enhancementReason"}
                                  rules={[
                                    { required: true, message: "Required" },
                                  ]}
                                  labelCol={{ span: 24 }}
                                  wrapperCol={{ span: 24 }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                  }}
                                >
                                  <Input
                                    disabled={true}
                                    defaultValue={props?.enhancementReasonOptions?.find((reason: any) => reason?.value === procedure?.enhancementReason)?.label}
                                    style={{ color: "black" }}
                                  />
                                </Form.Item>
                              </Col>
                            ) : (
                              <></>
                            )}

                            {props?.isCghsNew ? (
                              <Col span={8}>
                                <Button
                                  iconPosition="end"
                                  icon={
                                    procedure?.documents ? (
                                      <EyeOutlined
                                        style={{ marginLeft: "0.6rem" }}
                                        onClick={() =>
                                          props?.handleOpen(
                                            [procedure?.documents],
                                            procedure?.documents.documentLabelType
                                          )
                                        }
                                      />
                                    ) : null
                                  }
                                >
                                  Justification For Enhancement
                                </Button>
                              </Col>
                            ) : (
                              <></>
                            )}

                            <div style={{ width: "100%" }}>
                              <h4
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                Amount: ₹{" "}
                                {!procedure?.specialityType
                                  ?.toLowerCase()
                                  ?.includes("s") && !procedure?.unspecifiedProcedureAmount
                                  ? parseFloat(procedure?.numberOfDays) *
                                    parseFloat(procedure?.procedureAmount)
                                  : parseFloat(procedure?.numberOfDays) *
                                    parseFloat(
                                      procedure?.unspecifiedProcedureAmount
                                    )}
                                /-
                              </h4>
                            </div>
                          </Row>
                        )
                      )
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        NO PROCEDURE
                      </div>
                    )}

                    {item?.enhancementProceduresResponseList &&
                    item?.enhancementProceduresResponseList?.length > 0 ? (
                      <div style={{ width: "100%", marginBottom: "0.8rem" }}>
                        <h4 style={{ display: "flex", justifyContent: "end" }}>
                          Total Amount: ₹{" "}
                          {calculateTotal(
                            item?.enhancementProceduresResponseList
                          ) ?? 0}
                          /-
                        </h4>
                      </div>
                    ) : (
                      <></>
                    )}
                  </Form>
                </Panel>
                <Panel header="Documents" key="2">
                  {item?.enhancementDocuments &&
                  item?.enhancementDocuments?.length > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(6, 1fr)",
                        gap: 10,
                      }}
                    >
                      {item?.enhancementDocuments
                        // ?.filter(
                        //   (doc: any) =>
                        //     doc?.documentLabelType?.toUpperCase() === "OTHERS"
                        // )
                        ?.map((doc: any) => (
                          <div
                            key={doc.id}
                            style={{
                              border: "1px solid #eee",
                              padding: 10,
                              borderRadius: 8,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>
                              {doc.documentLabelType || doc.documentName}
                            </span>
                            <Button
                              type="link"
                              icon={<EyeOutlined />}
                              onClick={() =>
                                props?.handleOpen(
                                  item?.enhancementDocuments,
                                  doc?.documentLabelType
                                )
                              }
                            />
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      NO DOCUMENT UPLOADED
                    </div>
                  )}
                </Panel>
              </Collapse>
            </Card>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default ViewEnhancementCghs;
